import { useState } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import SelectionPage from '../../components/PageEditSelection/SelectionPage'
import toJS from '../../hoc/toJS';
import getData from '../../functions/getData'
import { PROGRAM_SELECTIONS_ITEMS, PROGRAM_ATTRIBUTES_GLOBAL, UI_PROGRAM, UI_GENERAL } from '../../constants/state'
import hasUpdateProgram from '../../hoc/hasUpdateProgram';
import { Redirect } from 'react-router-dom';
import config from '../../config.json'

const mapStateToProps = (state, ownProps) => ({
    selections: getData(state, PROGRAM_SELECTIONS_ITEMS),
    attributes: getData(state, PROGRAM_ATTRIBUTES_GLOBAL),
    displayDropzones: getData(state, [UI_PROGRAM, 'activeDropzones']),
    uiRequestOverlayType: getData(state, [UI_GENERAL, 'requestOverlay', 'overlayType'])
})

const SelectionPageContainer = ({
    selections,
    selectionId,
    defaultAllOpen = null,
    toogleAllOpenButtons = false,
     ...props
}) => {
    const [isAllOpen, setAllOpen] = useState(defaultAllOpen)
    const closePagePath = config.routes.program.path

    if(Object.keys(selections).length === 0) {
        return ''
    } else if(!selections.hasOwnProperty(selectionId)) {
        return <Redirect 
            to={closePagePath} 
        />
    } else {
        return <SelectionPage
            selectionId={selectionId}
            selection={selections[selectionId]}
            toogleAllOpenButtons={toogleAllOpenButtons}
            isAllOpen={isAllOpen}
            setAllOpen={setAllOpen}
            closePagePath={closePagePath}
            {...props}
        />
    }
}

export default compose(
    connect(mapStateToProps, null),
    hasUpdateProgram(),
    toJS()
)(SelectionPageContainer)